import type { ReactElement, ReactNode } from 'react';
import { Button, Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@shigo-ui/ui';

/** A widget link or action: a labelled ghost button, or an icon-only outlined button with a tooltip. */
export function WidgetActionButton({
  compact,
  label,
  icon,
  renderAction,
}: {
  compact: boolean | undefined;
  label: string;
  icon: ReactNode;
  renderAction: (content: ReactNode, ariaLabel?: string) => ReactElement;
}) {
  if (!compact) {
    return (
      <Button variant="ghost" size="sm" asChild>
        {renderAction(
          <>
            {icon}
            {label}
          </>,
        )}
      </Button>
    );
  }
  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button variant="outline" size="icon" className="text-muted-foreground size-8" asChild>
            {renderAction(icon, label)}
          </Button>
        </TooltipTrigger>
        <TooltipContent>{label}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
